import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const goTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer ftco-section">
      <div className="container">
        <div className="row">

          <div className="col-md-6 col-lg-4 mb-4">
            <h2 className="footer-heading">CLEAR & CLEAN</h2>
            <p>
              CLEAR & CLEAN is a full-service professional cleaning company
              delivering high-standard commercial cleaning solutions.
            </p>
          </div>

          <div className="col-md-6 col-lg-4">
            <h2 className="footer-heading">Quick Links</h2>
            <ul className="list-unstyled">
              <li><Link to="/" onClick={goTop}>Home</Link></li>
              <li><Link to="/about" onClick={goTop}>About</Link></li>
              <li><Link to="/services" onClick={goTop}>Services</Link></li>
              <li><Link to="/contact" onClick={goTop}>Contact</Link></li>
              
              <li><Link to="/blog" onClick={goTop}>Blog</Link></li>
              <li><Link to="/reviews" onClick={goTop}>Reviews</Link></li>
              <li><Link to="/faq" onClick={goTop}>FAQ</Link></li>
              <li><Link to="/all-services" onClick={goTop}>Related Cleaning Services</Link></li>
            </ul>
          </div>

          <div className="col-md-6 col-lg-4">
            <h2 className="footer-heading">Have a Question?</h2>
            <div class="block-23 mb-3">
            <ul>
            
                <li><a href="tel:+640220236511"><span class="icon fa fa-phone"></span><span class="text">+64 0220236511</span></a></li>
                 <li><a href="mailto:info@clearandclean.co.nz"><span class="icon fa fa-envelope"></span><span class="text">info@clearandclean.co.nz</span></a></li>
                  <li><span class="icon fa fa-map-marker"></span><span class="text">23 Conailus Street, Halswell, Christchurch</span></li>
            </ul>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;